const RadioButton = ({ button, setButton = () => {} }: { button: string; setButton?: () => void; index?: number }) => {
	return (
		<div className="radio-button" onClick={() => setButton()}>
			{button == "1" ? <div className="on" /> : ""}
		</div>
	);
};

export default RadioButton;
